import { ILocalStorageServiceConfig } from 'angular-2-local-storage';

export const localStorageServiceConfig: ILocalStorageServiceConfig = {
  prefix: 'valutrax',
  storageType: 'localStorage'
};
